import axios from "axios";
import {Loading} from "element-ui";
import qs from "qs";
import allConfig from "../common/config";
import {xwjStore} from "../store/store";
import {options} from './xssWhite'
import Vue from 'vue'
import { getLogoutSignStr } from '../common/utils'
import xss from "xss";
import Router from '../router'
// 请求状态标志
let isFormHeader = false
let isBlobHeader = false
let isAgainRequest = false
let needXssFilter = true
let ifMultipart = false

// 创建axios实例
const isDev = process.env.NODE_ENV === 'development'
const http = axios.create({
  baseURL: isDev ? '/api' : allConfig.baseUrl,
  withCredentials: false,
  timeout: 3000000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  },
  transformRequest: [function (data) {
    if (isAgainRequest) {
      return data
    }

    if (isFormHeader) {
      if (needXssFilter) {
        return xss(qs.stringify(data), options)
      } else if (ifMultipart) {
        return data
      } else {
        return qs.stringify(data)
      }
    } else {
      if (needXssFilter) {
        const xssReqData = xss(JSON.stringify(data), options)
        return JSON.stringify(data)
      } else {
        return JSON.stringify(data)
      }
    }
  }]
})
// Loading状态管理
let loading = null
let needLoadingRequestCount = 0
let showLogingOutConfirm = true
let refreshTokenFlag = false
let tokenRetryCount = 0  // token刷新重试次数
const MAX_TOKEN_RETRY = 3  // 最大重试次数

// 重试队列，每一项将是一个待执行的函数形式
const retryRequests = []

/**
 * 开始显示全屏Loading
 */
function startLoading() {
  loading = Loading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.5)'
  })
}

/**
 * 关闭全屏Loading
 */
function endLoading() {
  if (loading) {
    loading.close()
    loading = null
  }
}

/**
 * 显示全屏Loading（支持多个请求叠加）
 */
function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

/**
 * 尝试隐藏全屏Loading
 */
function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

/**
 * 刷新Token
 * @returns {Promise} 返回刷新Token的Promise
 */
function getRefreshToken() {
  isFormHeader = false
  isAgainRequest = false
  const refreshToken = sessionStorage.getItem('refreshToken')
  
  if (!refreshToken) {
    return Promise.reject(new Error('no refresh token'))
  }

  const nonceStr = Math.random().toString().replace('0.', '')
  const timeStamp = Date.parse(new Date())
  const sign = getLogoutSignStr(refreshToken, nonceStr, timeStamp)
  const reqData = {
    nonceStr,
    timestamp: timeStamp,
    sign,
    refreshToken
  }

  return apiAxios('POST', '/cas-member-manager/login/refreshToken', reqData)
}

/**
 * 请求拦截器
 */
http.interceptors.request.use(
  config => {
    // 设置请求头（直接设置属性，不替换整个headers对象）
    const token = sessionStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = token
    }
    
    const isCuser = sessionStorage.getItem('isCuser') === '1'
    config.headers['channelId'] = isCuser ? allConfig.cuserchannel : allConfig.buserchannel
    
    if (isCuser) {
      const memberInfoStr = sessionStorage.getItem('memberInfo')
      console.log('[HTTP Debug] isCuser:', isCuser)
      console.log('[HTTP Debug] memberInfoStr:', memberInfoStr)
      if (memberInfoStr) {
        try {
          const memberInfo = JSON.parse(memberInfoStr)
          console.log('[HTTP Debug] parsed memberInfo:', memberInfo)
          if (memberInfo && memberInfo.memberCode) {
            config.headers['userCode'] = memberInfo.memberCode
            config.headers['userTypeId'] = '20'
            console.log('[HTTP Debug] userCode set to:', memberInfo.memberCode)
          } else {
            console.warn('[HTTP Debug] memberInfo exists but no memberCode:', memberInfo)
          }
        } catch (e) {
          console.error('[HTTP] 解析 memberInfo 失败:', e)
        }
      } else {
        console.warn('[HTTP Debug] memberInfo not found in sessionStorage')
      }
    }
    
    // Content-Type 处理
    if (config.method !== 'get' && config.method !== 'GET') {
      const isFormData = config.data instanceof FormData
      if (isFormData) {
        // FormData 不设置 Content-Type，让浏览器自动设置 boundary
      } else if (isFormHeader) {
        config.headers['Content-Type'] = ifMultipart
          ? 'multipart/form-data'
          : 'application/x-www-form-urlencoded;charset=utf-8'
      } else {
        config.headers['Content-Type'] = 'application/json;charset=utf-8'
      }
    }
    
    // 打印调试信息 (仅在 debug 模式下)
    if (allConfig.debug) {
      console.log('[HTTP] Request URL:', config.url)
      console.log('[HTTP] Request headers:', JSON.stringify(config.headers))
    }
    
    // 强制打印关键请求信息，方便排查问题
    console.log('[HTTP Debug] Final Request URL:', config.url)
    console.log('[HTTP Debug] Final userCode header:', config.headers['userCode'])
    console.log('[HTTP Debug] Final channelId header:', config.headers['channelId'])
    console.log('[HTTP Debug] Final Authorization header:', config.headers['Authorization'] ? 'exists' : 'null')
    
    // XSS过滤处理
    if (config.params && needXssFilter) {
      const xssParam = xss(JSON.stringify(config.params))
      config.params = JSON.parse(xssParam)
    }

    return config
  },
  error => {
    console.error('请求拦截器错误:', error)
    return Promise.reject(error)
  }
)

/**
 * Token过期需要刷新的错误码
 */
const TOKEN_EXPIRED_CODES = ['30130', '6666', '66666']

/**
 * 清除用户登录信息
 */
function clearUserInfo() {
  sessionStorage.removeItem('token')
  sessionStorage.removeItem('refreshToken')
  sessionStorage.removeItem('memberInfo')
}

/**
 * 处理登录失效，跳转到登录页
 */
function handleLoginExpired() {
  clearUserInfo()
  const isCuser = sessionStorage.getItem('isCuser') === '1'
  // 清除 isCuser，让路由守卫重新判断
  sessionStorage.removeItem('isCuser')

  if (isCuser) {
    // C端用户 - 打开header登录dialog，不跳转页面
    // hash模式下，完整路由路径在hash中（去掉#前缀）
    const hashPath = window.location.hash || '#/'
    const fullPath = hashPath.startsWith('#') ? hashPath.slice(1) : hashPath
    sessionStorage.setItem('loginRedirectPath', fullPath)
    // 调用App.vue注册的getLogin方法打开登录弹窗
    const getLogin = xwjStore.get("getLogin")
    if (getLogin) {
      getLogin()
    } else {
      // fallback：如果getLogin未注册，跳转到首页
      window.location.hash = '#/'
    }
  } else {
    // B端用户 - 跳转到/login，保存完整redirect（hash模式下的完整路径）
    // 保持当前pathname（如/acs/），只修改hash部分
    const hashPath = window.location.hash || '#/'
    const fullPath = hashPath.startsWith('#') ? hashPath.slice(1) : hashPath
    const currentPathname = window.location.pathname
    window.location.href = currentPathname + '#/login?redirect=' + encodeURIComponent(fullPath)
  }
}

/**
 * 响应拦截器
 */
http.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // 处理404错误
    if (error.response?.data?.status === 404) {
      return Promise.reject(new Error('网络异常'))
    }

    const errCode = error.response?.data?.resultCode || ''
    // 将错误码转为字符串比较，兼容数字和字符串类型
    const errCodeStr = String(errCode)
    const shouldRefreshToken = TOKEN_EXPIRED_CODES.includes(errCodeStr) || refreshTokenFlag

    // 如果超过最大重试次数，不再刷新token
    if (tokenRetryCount >= MAX_TOKEN_RETRY) {
      Vue.prototype.$message?.error?.('登录已过期，请重新登录')
      handleLoginExpired()
      return Promise.reject(error)
    }

    if (!shouldRefreshToken) {
      return Promise.reject(error)
    }

    const config = error.response?.config
    if (!config) {
      return Promise.reject(error)
    }

    // 处理Token刷新
    if (!refreshTokenFlag) {
      refreshTokenFlag = true
      getRefreshToken()
        .then((data) => {
          refreshTokenFlag = false
          // 兼容数字和字符串类型的resultCode
          if (data.resultCode == 0 || data.resultCode === '0') {
            // 重置重试次数
            tokenRetryCount = 0
            // 保存新的token
            const token = data.data.token
            sessionStorage.setItem('token', token)
            sessionStorage.setItem('refreshToken', data.data.refreshToken)
            // 重新请求
            retryRequests.forEach(cb => cb(token))
            retryRequests.length = 0
          } else {
            // Token刷新失败
            tokenRetryCount++
            Vue.prototype.$message?.error?.(data.msg || '登录已过期，请重新登录')
            handleLoginExpired()
          }
        })
        .catch((err) => {
          refreshTokenFlag = false
          tokenRetryCount++
          if (err.message === 'no refresh token') {
            clearUserInfo()
          } else {
            handleLoginExpired()
          }
        })
    } else {
      // 如果正在刷新Token，且当前请求就是刷新Token的请求，说明刷新失败
      if (config.url?.indexOf('/login/refreshToken') !== -1) {
        handleLoginExpired()
        return Promise.reject(error)
      }
    }

    // 返回Promise，等待Token刷新后重试（无论是否正在刷新token，都把请求加入队列）
    return new Promise((resolve, reject) => {
      retryRequests.push((token) => {
        try {
          config.headers['Authorization'] = token
          config.url = config.url.replace('/api/', '/')
          isAgainRequest = true
          resolve(http(config))
        } catch (err) {
          reject(err)
        }
      })
    })
  }
)

/**
 * API请求封装
 * @param {string} method - 请求方法 (GET/POST/PUT/DELETE)
 * @param {string} url - 请求URL
 * @param {object} params - 请求参数
 * @param {boolean} isLoading - 是否显示Loading
 * @returns {Promise} 返回Promise
 */
function apiAxios(method, url, params, isLoading) {
  return new Promise((resolve, reject) => {
    if (isLoading) {
      showFullScreenLoading()
    }

    http({
      method: method.toUpperCase(),
      url,
      data: (method === 'POST' || method === 'PUT') ? params : null,
      params: (method === 'GET' || method === 'DELETE') ? params : null,
      responseType: isBlobHeader ? 'blob' : null
    })
      .then((res) => {
        if (isLoading) {
          tryHideFullScreenLoading()
        }
        showLogingOutConfirm = true

        if (res.status === 200) {
          resolve(res.data)
        } else if (res.status === 404) {
          reject(new Error('系统异常'))
        } else {
          reject(new Error('系统异常'))
        }
      })
      .catch((err) => {
        if (isLoading) {
          tryHideFullScreenLoading()
        }

        // 请求超时或网络错误
        if (!err.response) {
          reject(new Error('系统异常'))
          return
        }

        // 404错误
        if (err.isAxiosError && err.response?.status === 404) {
          reject(new Error('资源不存在'))
          return
        }

        // 401错误已经在拦截器中处理
        if (err.message === 'Request failed with status code 401') {
          reject(new Error('未授权'))
          return
        }

        // 其他错误
        reject(err.message || new Error('系统异常'))
      })
  })
}

/**
 * HTTP请求封装模块
 */
export default {
  /**
   * GET请求
   * @param {string} url - 请求URL
   * @param {object} params - 请求参数
   * @param {boolean} isFormData - 是否使用form-data格式，默认true
   * @param {boolean} isLoading - 是否显示Loading，默认false
   * @param {boolean} isBlob - 响应类型是否为blob，默认false
   * @returns {Promise} 返回Promise
   */
  get(url, params, isFormData = true, isLoading = false, isBlob = false) {
    isFormHeader = isFormData
    isBlobHeader = isBlob
    isAgainRequest = false
    return apiAxios('GET', url, params, isLoading)
  },

  /**
   * POST请求
   * @param {string} url - 请求URL
   * @param {object} params - 请求参数
   * @param {boolean} isFormData - 是否使用form-data格式，默认false
   * @param {boolean} isLoading - 是否显示Loading，默认false
   * @param {boolean} needXss - 是否需要XSS过滤，默认true
   * @param {boolean} ifMultipartFlag - 是否为multipart格式，默认false
   * @param {boolean} isBlob - 响应类型是否为blob，默认false
   * @returns {Promise} 返回Promise
   */
  post(url, params, isFormData = false, isLoading = false, needXss = true, ifMultipartFlag = false, isBlob = false) {
    isFormHeader = isFormData
    isAgainRequest = false
    ifMultipart = ifMultipartFlag
    needXssFilter = needXss
    isBlobHeader = isBlob
    return apiAxios('POST', url, params, isLoading)
  },

  /**
   * PUT请求
   * @param {string} url - 请求URL
   * @param {object} params - 请求参数
   * @returns {Promise} 返回Promise
   */
  put(url, params) {
    isAgainRequest = false
    return apiAxios('PUT', url, params)
  },

  /**
   * DELETE请求
   * @param {string} url - 请求URL
   * @param {object} params - 请求参数
   * @returns {Promise} 返回Promise
   */
  delete(url, params) {
    isAgainRequest = false
    return apiAxios('DELETE', url, params)
  }
}
